var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hm-tower",class:{ 'hm-tower--horizontal': _vm.horizontal }},[_c('div',{staticClass:"hm-tower__title"},[_vm._t("title")],2),_c('div',{staticClass:"hm-tower__body"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }